import React, { useEffect, useState } from 'react';
import { WheelConfiguration } from '@luckycart/xpn-types';

import {
  NeedleContainer,
  SpinnerContainer,
  WheelContainer,
  WheelLostImage,
  WheelWinImage,
} from './WheelPlugin.style';

import { ReactComponent as WheelSVG } from './images/wheel.svg';
import { ReactComponent as NeedleSVG } from './images/arrow.svg';
import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { ALT_ATTRIBUTE_STATIC_MESSAGE } from '../../utils/AltAttributeStaticMessage';

interface Props {
  config: WheelConfiguration;
  onPluginDone?: () => void;
  hasWon: null | boolean;
  addEditableBlock?: (block: BlockInfoType) => void;
  removeEditableBlock?: (configPath: string) => void;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  isPlaying: boolean;
  isEdition: boolean;
  onLoad?: () => void;
}

export const WheelPlugin: React.FunctionComponent<Props> = ({
  config,
  hasWon,
  onPluginDone,
  addEditableBlock,
  removeEditableBlock,
  onBlockEdit,
  isPlaying,
  isEdition,
  onLoad,
}: Props) => {
  const [
    isStopping,
    setIsStopping,
  ] = useState<boolean>(false);

  useEffect(() => {
    setIsStopping(false);
  }, []);

  const handleAnimationIteration = (): void => {
    if (isPlaying === true && isStopping === false && hasWon !== null) {
      setIsStopping(true);
      if (onPluginDone) {
        setTimeout(
          () => onPluginDone(),
          // eslint-disable-next-line no-magic-numbers
          5000 + 2000
        );
      }
    }
  };

  const dataTemplateType = 'plugin';
  const dataTemplateConfig = 'screens.game.plugin';
  const displayName = 'plugin';

  return (
    <WheelContainer
      onBlockEdit={onBlockEdit}
      dataTemplateType={dataTemplateType}
      displayName={displayName}
      dataTemplateConfig={dataTemplateConfig}
      isEdition={isEdition}
      winColor={config.win.color}
      loseColor={config.lose.color}
      addEditableBlock={addEditableBlock}
      removeEditableBlock={removeEditableBlock}
      onLoad={onLoad}
      neededAssets={[config.win.imageUrl, config.lose.imageUrl]}
    >
      <SpinnerContainer isPlaying={isPlaying} isStopping={isStopping} hasWon={hasWon} onAnimationIteration={handleAnimationIteration}>
        {
          config.win.imageUrl !== undefined && config.win.imageUrl !== null &&
          <WheelWinImage>
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.win.imageUrl } />
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.win.imageUrl } />
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.win.imageUrl } />
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.win.imageUrl } />
          </WheelWinImage>
        }
        {
          config.lose.imageUrl !== undefined && config.lose.imageUrl !== null &&
          <WheelLostImage>
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.lose.imageUrl } />
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.lose.imageUrl } />
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.lose.imageUrl } />
            <img alt={ALT_ATTRIBUTE_STATIC_MESSAGE} src={ config.lose.imageUrl } />
          </WheelLostImage>
        }
        <WheelSVG />
      </SpinnerContainer>
      <NeedleContainer>
        <NeedleSVG />
      </NeedleContainer>
    </WheelContainer>
  );
};
